import facepaint from "facepaint";

export const widths = ["420px", "920px", "1120px", "1400px"];

export const queries = widths.map(width => `(min-width: ${width})`);

const mediaQueries = facepaint(queries.map(query => `@media${query}`));

export default mediaQueries;
